export default {
  collapse: 'Collapse',
  poweredBy: 'Powered by:',
};
